export function patchItem ({ collection, identifier, patch }) {
  return collection.map(item => {
    if (item[identifier] === patch[identifier]) {
      return { ...item, ...patch }
    }
    return item
  })
}
